import React from 'react';

import { IBlogPost } from '../../../types/contentful';

import { PageProps } from '../../context/PageData';

import { Body } from '../Body';
import { BlogPostHero } from '../BlogComponents/BlogPostHero';
import { BlogPostBody } from './BlogPostBody';
import { MorePosts } from './MorePosts';
import { ShareButtons } from './ShareButtons';

export function BlogPost({ blogPostData, query }: PageProps) {
  const { fields, sys } = (blogPostData as IBlogPost) ?? {};
  const { seoMetadata } = fields ?? {};

  return fields ? (
    <Body {...fields} query={query} pathPrefix="/blog">
      <BlogPostHero {...fields} sysId={sys?.id} />
      <ShareButtons {...seoMetadata?.fields} />
      <BlogPostBody {...fields} />
      <MorePosts sysId={sys?.id} />
    </Body>
  ) : null;
}
